import apiClient from '../../../api/apiClient';
import { MANAGER_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = MANAGER_REST_API_BASE_URL;

export const getAllUserAssignments = () =>
  apiClient.get(`${REST_API_BASE_URL}/assignments`);

export default apiClient;
